// extracted by mini-css-extract-plugin
module.exports = {"paypalBnplMessage":"PayPalBnplMessage_paypalBnplMessage__D744m"};